<template>
  <v-dialog v-model="openDialog"
            max-width="500" lazy>
    <v-card>
      <v-card-title class="title">
        {{load.pendingSchedule.title}}
      </v-card-title>

      <v-layout column class="px-3">
        <v-flex>
          <label><b>Load Count:</b> {{load.pendingSchedule.loadCount}}</label>
        </v-flex>
        <v-flex>
          <label>
            <b>Scheduled pickup date:</b>
            {{load.pendingSchedule.date | formatDay}}
            {{load.pendingSchedule.localPickupTime}}
            <i>({{load.pendingSchedule.localTimezone}})</i>
          </label>
        </v-flex>
        <v-flex>
          <label><b>From:</b> {{fromRegion}}</label> <br>
          <label><b>To:</b> {{toRegion}}</label>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-card-actions>
          <v-spacer />
          <v-btn flat
                 @click="$emit('repeat', load)"
                 color="accent">
            <v-icon class="mr-2">sync</v-icon>
            Repeat load
          </v-btn>
          <v-btn flat
                 @click="openDialog = false"
                 :to="{
                   name: 'company.loads.repeat.section',
                   params: { id: companyId, repeatLoadId: load.humanId }
                 }"
                 color="accent">
            <v-icon class="mr-2">edit</v-icon>
            View/Edit
          </v-btn>
        </v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import loadGroupMixin from '@/mixins/loadGroupMixin';

export default {
  name: 'ScheduleLoadCalendarDialog',
  props: {
    value: {
      type: Boolean,
    },
    load: {
      type: Object,
    },
    companyId: {
      type: String,
    },
  },
  mixins: [
    loadGroupMixin,
  ],
  data() {
    return {
      openDialog: this.value,
    };
  },
  watch: {
    value() {
      this.openDialog = this.value;
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  computed: {
    fromRegion() {
      return this.loadGroupPickupLocationGooglePlace(this.load).region;
    },
    toRegion() {
      return this.loadGroupDropoffLocationGooglePlace(this.load).region;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/components/dialogs/ScheculeLoadCalendarDialog.vue